import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ScrollToTop from "@/components/ScrollToTop";
import PublicLayout from "@/components/layout/PublicLayout";

import Home from "@/pages/Home";
import Libros from "@/pages/Libros";
import Ebooks from "@/pages/Ebooks";
import LibrosIglesia from "@/pages/LibrosIglesia";
import Distribuidores from "@/pages/Distribuidores";
import BookDetail from "@/pages/BookDetail";
import Autores from "@/pages/Autores";
import AuthorDetail from "@/pages/AuthorDetail";
import Publica from "@/pages/Publica";
import Nosotros from "@/pages/Nosotros";
import Recursos from "@/pages/Recursos";
import Contacto from "@/pages/Contacto";
import AvisoLegal from "@/pages/AvisoLegal";
import Privacidad from "@/pages/Privacidad";
import Cookies from "@/pages/Cookies";
import CondicionesVenta from "@/pages/CondicionesVenta";
import NotFound from "@/pages/NotFound";
import CompraCompletada from "@/pages/CompraCompletada";
import AdminVentas from "@/pages/admin/AdminVentas";
import AdminCustomers from "@/pages/admin/AdminCustomers";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminBooks from "@/pages/admin/AdminBooks";
import AdminAuthors from "@/pages/admin/AdminAuthors";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminResources from "@/pages/admin/AdminResources";
import AdminHero from "@/pages/admin/AdminHero";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminSubscribers from "@/pages/admin/AdminSubscribers";

function P({ children }) {
  return <PublicLayout>{children}</PublicLayout>;
}

function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  const location = useLocation();
  if (!ready) return <div className="min-h-screen flex items-center justify-center bg-[#eceae4] text-[#8a8a83]">Cargando...</div>;
  if (!user) return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<P><Home /></P>} />
          <Route path="/libros" element={<P><Libros /></P>} />
          <Route path="/ebooks" element={<P><Ebooks /></P>} />
          <Route path="/libros-en-tu-iglesia" element={<P><LibrosIglesia /></P>} />
          <Route path="/distribuidores" element={<P><Distribuidores /></P>} />
          <Route path="/libros/:slug" element={<P><BookDetail /></P>} />
          <Route path="/autores" element={<P><Autores /></P>} />
          <Route path="/autores/:slug" element={<P><AuthorDetail /></P>} />
          <Route path="/publica-con-harvest" element={<P><Publica /></P>} />
          <Route path="/nosotros" element={<P><Nosotros /></P>} />
          <Route path="/gratis" element={<P><Recursos /></P>} />
          <Route path="/recursos-gratuitos" element={<Navigate to="/gratis" replace />} />
          <Route path="/contacto" element={<P><Contacto /></P>} />
          <Route path="/compra/completada" element={<P><CompraCompletada /></P>} />
          <Route path="/aviso-legal" element={<P><AvisoLegal /></P>} />
          <Route path="/politica-de-privacidad" element={<P><Privacidad /></P>} />
          <Route path="/politica-de-cookies" element={<P><Cookies /></P>} />
          <Route path="/condiciones-de-venta" element={<P><CondicionesVenta /></P>} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<AdminDashboard />} />
            <Route path="portada" element={<AdminHero />} />
            <Route path="autor-del-mes" element={<Navigate to="/admin/portada" replace />} />
            <Route path="libros" element={<AdminBooks />} />
            <Route path="ventas" element={<AdminVentas />} />
            <Route path="clientes" element={<AdminCustomers />} />
            <Route path="autores" element={<AdminAuthors />} />
            <Route path="categorias" element={<AdminCategories />} />
            <Route path="gratis" element={<AdminResources />} />
            <Route path="contactos" element={<AdminContacts />} />
            <Route path="suscriptores" element={<AdminSubscribers />} />
          </Route>

          <Route path="*" element={<P><NotFound /></P>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
